/*
"ItemsByCategory": {
    "required": ["code", "name", "abbreviation", "itemCount"],
    "type": "object",
    "properties": {
        "code": {
            "description": "Schnittstellen-Code der Gegenstandskategorie",
            "type": "string"
        },
        "name": {
            "description": "Name der Gegenstandskateogrie",
            "type": "string"
        },
        "abbreviation": {
            "description": "Abkürzung der Gegenstandskategorie",
            "type": "string"
        },
        "itemCount": {
            "format": "int32",
            "description": "Anzahl aller zu ladenden und zu entladenden Gegenstände",
            "type": "integer"
        }
    }
}
 */
export class ItemsByCategory {

  constructor(
    public code: string,
    public name: string,
    public abbreviation: string,
    public itemCount: number
  ) {
  }

  public static fromJSON(json: {
    code: string,
    name: string,
    abbreviation: string,
    itemCount: number
  }): ItemsByCategory {
    if (!json) {
      throw new Error('ItemsByCategory JSON should not be undefined');
    }
    if (json.code === undefined || json.code === null) {
      throw new Error('ItemStatus JSON should have property: code');
    }
    if (json.name === undefined || json.name === null) {
      throw new Error('ItemStatus JSON should have property: name');
    }
    if (json.abbreviation === undefined || json.abbreviation === null) {
      throw new Error('ItemStatus JSON should have property: abbreviation');
    }
    if (json.itemCount === undefined || json.itemCount === null) {
      throw new Error('ItemStatus JSON should have property: itemCount');
    }
    return new ItemsByCategory(json.code, json.name, json.abbreviation, json.itemCount);
  }
}
